module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-log",
    attrs: {
      "id": "gv-difesa-suolo-foto-log"
    }
  }, [_vm._c('div', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    staticClass: "gv-difesa-suolo-foto-log-title gv-color-scheme",
    attrs: {
      "id": "gv-difesa-suolo-foto-log-title"
    }
  }, [_vm._v("\n    Difesa Suolo: LOG ERRORI\n    "), _vm._c('el-button', {
    staticClass: "gv-close gv-color-scheme",
    attrs: {
      "icon": "el-icon-close",
      "type": "button",
      "title": "Chiudi Panello",
      "alt": "Chiudi Panello"
    },
    on: {
      "click": _vm.closePanel
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-log-wrapper gv-inverted-color-scheme",
    attrs: {
      "id": "gv-difesa-suolo-foto-log-wrapper"
    }
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-log-body gv-inverted-color-scheme",
    attrs: {
      "id": "gv-difesa-suolo-foto-log-body"
    }
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-log-select"
  }, [_vm._c('b', [_vm._v("SESSIONE")]), _vm._v(" "), _vm._c('el-select', {
    attrs: {
      "size": "mini"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.sel_session),
      callback: function($$v) {
        _vm.sel_session = $$v
      },
      expression: "sel_session"
    }
  }, _vm._l((_vm.sessions), function(item) {
    return _vm._c('el-option', {
      key: item.session,
      attrs: {
        "value": item.session,
        "label": item.session
      }
    }, [_vm._c('span', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.session))])])
  }))], 1), _vm._v(" "), _vm._c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "Nessun Log",
      "data": _vm.sel_logs,
      "size": "mini"
    }
  }, [_vm._c('el-table-column', {
    attrs: {
      "label": "Nome Foto",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.row.file_name) + " ")]
      }
    }])
  }), _vm._v(" "), _vm._c('el-table-column', {
    attrs: {
      "label": "Errore",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.row.errore) + " ")]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c42bf2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DifesaSuoloFotoLog.vue
// module id = 882
// module chunks = 39